import { createSlice } from "@reduxjs/toolkit";

import { ENTITY_TYPE, userRoleType } from "../../constants/phase";
import { magnifiSuperAdminEntityId } from "../../containers/app/utils";
import { getEntityType } from "../../helpers";
import LocalStorage from "../../utils/LocalStorage";
import { getMyProfile } from "../user/actions";

const initialState = {
  selectedEntityId: "",
};

export const entitySlice = createSlice({
  name: "entity",
  initialState: initialState,
  reducers: {
    setSelectedEntityId: (state, action) => {
      state.selectedEntityId = action.payload;
      LocalStorage.setItem("entityId", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMyProfile.fulfilled, (state, action) => {
      const { status, data } = action.payload;
      if (status) {
        const { roleType, entity } = data;
        if (roleType === userRoleType.superAdmin) {
          state.selectedEntityId = magnifiSuperAdminEntityId;
        } else {
          if (entity) {
            const { organizations, workspaces } = entity;
            const prevEntity = LocalStorage.getItem("entityId");
            const entityType = getEntityType(prevEntity);
            if (entityType === ENTITY_TYPE.ORGANIZATION) {
              const entityDetails = organizations.find(({ organizationId }) => organizationId === prevEntity);
              if (entityDetails) {
                state.selectedEntityId = prevEntity;
              } else {
                const firstEntity = organizations?.[0] || workspaces?.[0];
                if (firstEntity) {
                  state.selectedEntityId = firstEntity?.organizationId || firstEntity?.workspaceId;
                  LocalStorage.setItem("entityId", state.selectedEntityId);
                }
              }
            } else if (entityType === ENTITY_TYPE.WORKSPACES) {
              const entityDetails = workspaces.find(({ workspaceId }) => workspaceId === prevEntity);
              if (entityDetails) {
                state.selectedEntityId = prevEntity;
              } else {
                const firstEntity = organizations?.[0] || workspaces?.[0];
                if (firstEntity) {
                  state.selectedEntityId = firstEntity?.organizationId || firstEntity?.workspaceId;
                  LocalStorage.setItem("entityId", state.selectedEntityId);
                }
              }
            } else {
              const firstEntity = organizations?.[0] || workspaces?.[0];
              if (firstEntity) {
                state.selectedEntityId = firstEntity?.organizationId || firstEntity?.workspaceId;
                LocalStorage.setItem("entityId", state.selectedEntityId);
              }
            }
          }
        }
      }
    });
  },
});

export const { setSelectedEntityId } = entitySlice.actions;

export default entitySlice.reducer;
